import { render, staticRenderFns } from "./SwappMethod.vue?vue&type=template&id=0a9cfdb4&scoped=true&"
import script from "./SwappMethod.vue?vue&type=script&lang=js&"
export * from "./SwappMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9cfdb4",
  null
  
)

export default component.exports